import GetParentPathRequest from '@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetParentPathRequest';
import { SettingsBreadcrumbsModel, GroupModel, NamespaceModel, QueueTasksModel } from '../models';
import ProjectNamespaceTreeItem from '@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceTreeItem';
import ProjectGroupTreeItem from '@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectGroupTreeItem';
import ProjectQueueTaskListItem from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListItem';

export const mapGetBreadcrumbsRequest = (request: SettingsBreadcrumbsModel) =>
  new GetParentPathRequest({
    NamespaceId: request.NamespaceId,
    GroupId: request.GroupId,
    QueueTaskId: request.QueueId,
  });
const mapGetBreadcrumbsQueue = (parent: ProjectGroupTreeItem | ProjectNamespaceTreeItem) => {
  if (!parent.QueueTasks?.length) return undefined;
  const result = new QueueTasksModel({
    Id: parent.QueueTasks[0].Id,
    Name: parent.QueueTasks[0].Name,
    NamespaceId: parent.QueueTasks[0].NamespaceId,
  });
  if (typeof parent.Id == 'string') {
    result.NamespaceId = parent.Id;
  } else if (typeof parent.Id == 'number') {
    result.ParentGroupId = parent.Id;
  }
  return result;
};
export const mapGetBreadcrumbsGroup = (group: ProjectGroupTreeItem) => {
  return new GroupModel({
    Id: group.Id,
    Name: group.Name,
    NamespaceId: group.NamespaceId,
    ParentGroupId: group.ParentGroupId,
    Group: group.ChildrenGroups?.length
      ? mapGetBreadcrumbsGroup(group.ChildrenGroups[0])
      : undefined,
    QueueTask: mapGetBreadcrumbsQueue(group),
  });
};

export const mapGetBreadcrumbsResponse = (response: ProjectNamespaceTreeItem) =>
  new NamespaceModel({
    Id: response.Id,
    Name: response.Name,
    IconId: response.IconId,
    IconUrl: response.IconUrl,
    ColorId: response.ColorId,
    Color: response.Color,
    Group: response.Groups?.length ? mapGetBreadcrumbsGroup(response.Groups[0]) : undefined,
    QueueTask: mapGetBreadcrumbsQueue(response),
  });
